import axios from 'axios'
import {BASE_API} from'../helpers/base'
import { defaultLocale } from '../plugins/i18n'
import store from '../store'

export function getLoggedUser(id){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.get(`${BASE_API}/get_user_by_id/${id}`, {headers});
}

export function updateUser(id,data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.put(`${BASE_API}/update_information/${id}`,data,{headers});
}

export function payBill(data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.post(`${BASE_API}/pay`, data, {headers});
}

export function initPayment(data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.post(`${BASE_API}/initPayment`, data, {headers});
}

export function confirmPayment(data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.post(`${BASE_API}/confirmPayment`, data, {headers});
}

export function saveAcceptTest(id,data){
  const headers =  {Authorization: `Bearer ${ localStorage.getItem('token') }`};
  return axios.post(`${BASE_API}/accept_questionnaire_test/${id}`,data,{headers});
}

export function ifNotAuthenticated(to, from, next){
  if (!store.getters.isLoggedIn) {
    next();
    return
  }
  next({
    path: `/${defaultLocale}/account`
  });
}

export function ifAuthenticated(to, from, next){
  if (store.getters.isLoggedIn) {
    next();
    return
  }
  next({
    path: `/${defaultLocale}`
  });
}

export function isTalentApp(){
  const host =  window.location.host;
  return host.includes("talent");
}

export function isVenteApp(){
  const host =  window.location.host;
  return host.includes("vente");
}

export function isTalentOrVenteApp(){
  return (isTalentApp() || isVenteApp());
}

export function hasColor(userInfo){
  return (userInfo.questionnaire_repondu.bilandepart != null && userInfo.questionnaire_repondu.bilandepart != '' && userInfo.questionnaire_repondu.bilandepart != '-');
}
export function hasTalent(userInfo){
  return (userInfo.questionnaire_repondu.bilantalent != null && userInfo.questionnaire_repondu.bilantalent != '' && userInfo.questionnaire_repondu.bilantalent != '-');
}

export function getBillTalent(userInfo){
  let totalBill = 0;
  if ( hasColor(userInfo) && (userInfo.paye == '' || userInfo.paye == null) && userInfo.talent_payement_date == null ) {
    totalBill = userInfo.facture_item_color_talent
    // Dans le cas ou le questionnaire talent est gratuit
    if (parseInt(userInfo.facture_item_talent)<= 0)
      totalBill = userInfo.facture_item_color
  } else if (userInfo.talent_payement_date == null) {
    totalBill = userInfo.facture_item_talent
  }
  return totalBill;
}

export function getBillColor(userInfo){
  let totalBill = 0;
  if ( hasTalent(userInfo) && userInfo.talent_payement_date == null && (userInfo.paye == '' || userInfo.paye == null) ) {
    totalBill = userInfo.facture_item_color_talent
    // Dans le cas ou le questionnaire talent est gratuit
    if (parseInt(userInfo.facture_item_talent)<= 0)
      totalBill = userInfo.facture_item_color
  } else if (userInfo.paye == '' || userInfo.paye == null) {
    totalBill = userInfo.facture_item_color
  }
  return totalBill;
}

export function willPayColorAndTalent(userInfo){
  let willPay = false;

  if (isTalentApp()) {
    if ( hasColor(userInfo) && (userInfo.paye == '' || userInfo.paye == null) && userInfo.talent_payement_date == null ) {
      willPay = true;
    }
  } else {
    if ( hasTalent(userInfo) && userInfo.talent_payement_date == null && (userInfo.paye == '' || userInfo.paye == null) ) {
      willPay = true;
    }
  }
  return willPay;
}

export function hasCompleteAccount(userInfo){
  let finish = true;
  if ( userInfo.civilite == "" || userInfo.country == ""
    || (!isTalentApp() && (userInfo.paye == '' || userInfo.paye == null))
    || (isTalentApp() && userInfo.relation_groupe.type_client == "particulier" && userInfo.talent_payement_date == null) ) {
    finish = false;
  }
  return finish;
}



// WEBPACK FOOTER //
// ./src/services/User.service.js